import { render, staticRenderFns } from "./AllocateForm.vue?vue&type=template&id=282e1f60&scoped=true&"
import script from "./AllocateForm.vue?vue&type=script&lang=js&"
export * from "./AllocateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282e1f60",
  null
  
)

export default component.exports